import { Head } from "@inertiajs/react";

interface StructuredDataProps {
    type: "SoftwareApplication" | "FAQPage" | "Organization";
    data: any;
}

export default function StructuredData({ type, data }: StructuredDataProps) {
    const getSchemaData = () => {
        switch (type) {
            case "SoftwareApplication":
                return {
                    "@context": "https://schema.org",
                    "@type": "SoftwareApplication",
                    name: data.name || "CryptoTax",
                    applicationCategory: "FinanceApplication",
                    offers: {
                        "@type": "Offer",
                        price: data.price || "1997",
                        priceCurrency: "BRL",
                    },
                    operatingSystem: "Web",
                    description:
                        data.description ||
                        "Plataforma completa para declaração de imposto de renda de criptomoedas. Suporte para exchanges brasileiras e internacionais, carteiras DeFi e integração com contadores.",
                    aggregateRating: {
                        "@type": "AggregateRating",
                        ratingValue: "4.8",
                        ratingCount: "150",
                    },
                    url: "https://cryptotax.com.br",
                };

            case "Organization":
                return {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: "CryptoTax",
                    url: "https://cryptotax.com.br",
                    logo: "https://cryptotax.com.br/logo-black.webp",
                    description:
                        "Plataforma líder no Brasil para declaração de imposto de renda de criptomoedas",
                    address: {
                        "@type": "PostalAddress",
                        addressCountry: "BR",
                    },
                    sameAs: [
                        "https://www.instagram.com/cryptotax.com.br",
                        "https://www.linkedin.com/company/cryptotax",
                    ],
                    contactPoint: {
                        "@type": "ContactPoint",
                        contactType: "customer support",
                        availableLanguage: ["Portuguese", "English"],
                    },
                };

            case "FAQPage":
                return {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    mainEntity: data.questions || [],
                };

            default:
                return {};
        }
    };

    return (
        <Head>
            <script type="application/ld+json">
                {JSON.stringify(getSchemaData())}
            </script>
        </Head>
    );
}
